import { createSelector } from 'reselect'

const selector = state => state.recurringReducer

export const recurringFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const recurringLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const recurringLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const recurringErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const recurringOffersSelector = createSelector(
  [selector],
  ({ recurrings }) => recurrings
)

export const recurringNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const recurringAddSelector = createSelector(
  [selector],
  ({ addLoading, addError }) => ({ addLoading, addError })
)

export const recurringEditSelector = createSelector(
  [selector],
  ({ editLoading, editError }) => ({ editLoading, editError })
)

export const recurringDeleteSelector = createSelector(
  [selector],
  ({ deleteLoad, deleteError }) => ({ deleteLoad, deleteError })
)

export const recurringSelector = createSelector(
  [selector],
  recurring => recurring
)
